module.exports = "<list-view\n  page=\"$ctrl.page\"\n  limit=\"$ctrl.limit\"\n  item-state=\"ticket\"\n  paginate-event=\"$ctrl.paginateEvent\"\n  title=\"Tickets\"\n  resource=\"Ticket\"\n  transformer=\"TicketsTransforms\"\n  no-items-text=\"No Tickets Yet!\"\n></list-view>\n\n<main-footer></main-footer>\n<main-sidenav sections=\"$ctrl.sections\">\n  <main-sidenav></main-sidenav>\n</main-sidenav>\n";


//////////////////
// WEBPACK FOOTER
// ./src/pages/tickets/tickets.html
// module id = 1597
// module chunks = 0